/** @format */

import React, { useState } from "react";
import { useEffect } from "react";
import { getSellerProfile, sellerIsBlock, getSellerProduct } from "../../../store/seller/seller.action";
import { connect, useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getDefaultCurrency } from "../../../store/currency/currency.action";
import defaultImage from "../../../../assets/images/default.jpg";
import { formatAmount } from "../../../extra/functions";
import InitialsAvatar from "../../../extra/InitialsAvatar";

const Shop = (props) => {
	const { sellerProfile } = useSelector((state) => state.seller);

	const { defaultCurrency } = useSelector((state) => state.currency);
	const { state } = useLocation();
	const id = state;

	const dispatch = useDispatch();
	const [lightboxImage, setLightboxImage] = useState(null);

	useEffect(() => {
		dispatch(getSellerProfile(id));
		dispatch(getDefaultCurrency());
	}, [dispatch]);

	const fullName = `${sellerProfile?.firstName || ""} ${sellerProfile?.lastName || ""}`.trim();
	const docs = [
		{ label: "Utility Bill", sub: "Proof of Address", field: "addressProof", icon: "bi-receipt" },
		{ label: "Government ID", sub: "Proof of Identification", field: "govId", icon: "bi-person-vcard" },
		{ label: "Registration Certificate", sub: "Business Registration", field: "registrationCert", icon: "bi-file-earmark-text" },
	];
	const hasDocs = docs.some((d) => sellerProfile?.[d.field]);

	return (
		<>
			<div className='seller-shop-detail mt-4'>
				<div className='row'>
					{/* Profile / Personal Info */}
					<div className='col-xl-6 col-md-12 pb-3'>
						<div className='profile-card'>
							<div className='profile-card-header'>
								<i className='bi bi-person-fill me-2' style={{ color: "#e54a13" }}></i>
								<span>Personal Information</span>
							</div>
							<div className='profile-card-body'>
								<div className='d-flex flex-column flex-md-row align-items-center align-items-md-start' style={{ gap: "20px" }}>
									<div className='text-center'>
										<InitialsAvatar src={sellerProfile?.image} name={fullName} size={110} rounded={12} style={{ border: "3px solid #e2e8f0" }} />
										{sellerProfile?.businessTag && (
											<div className='mt-2' style={{ fontSize: "12px", color: "#64748b" }}>
												@{sellerProfile.businessTag}
											</div>
										)}
									</div>
									<div className='flex-grow-1 w-100'>
										<div className='row'>
											<div className='col-sm-6'>
												<Field label='Full Name' value={fullName || "-"} strong />
												<Field label='Email' value={sellerProfile?.email} />
												<Field label='Mobile number' value={sellerProfile?.mobileNumber} />
												<Field label='Gender' value={sellerProfile?.gender} />
											</div>
											<div className='col-sm-6'>
												<Field
													label='Instagram'
													value={
														sellerProfile?.instagramHandle ? (
															<a href={`https://instagram.com/${sellerProfile.instagramHandle}`} target='_blank' rel='noopener noreferrer' style={{ color: "#e54a13", textDecoration: "none" }}>
																@{sellerProfile.instagramHandle}
															</a>
														) : (
															"-"
														)
													}
												/>
												<Field
													label='TikTok'
													value={
														sellerProfile?.tiktokHandle ? (
															<a href={`https://tiktok.com/@${sellerProfile.tiktokHandle}`} target='_blank' rel='noopener noreferrer' style={{ color: "#e54a13", textDecoration: "none" }}>
																@{sellerProfile.tiktokHandle}
															</a>
														) : (
															"-"
														)
													}
												/>
												<Field label={`Total Earned (${defaultCurrency?.symbol || ""})`} value={sellerProfile?.netPayout ? formatAmount(sellerProfile.netPayout) : "-"} />
												<Field label={`Total Withdrawn (${defaultCurrency?.symbol || ""})`} value={sellerProfile?.amountWithdrawn ? formatAmount(sellerProfile.amountWithdrawn) : "-"} />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* Address */}
					<div className='col-xl-6 col-md-12 pb-3'>
						<div className='profile-card'>
							<div className='profile-card-header'>
								<i className='bi bi-geo-alt-fill me-2' style={{ color: "#f59e0b" }}></i>
								<span>Address</span>
							</div>
							<div className='profile-card-body'>
								<div className='row'>
									<div className='col-sm-6'>
										<Field label='Address' value={sellerProfile?.address?.address} />
										<Field label='City' value={sellerProfile?.address?.city} />
										<Field label='Pincode' value={sellerProfile?.address?.pincode || sellerProfile?.address?.pinCode} />
									</div>
									<div className='col-sm-6'>
										<Field label='Landmark' value={sellerProfile?.address?.landMark} />
										<Field label='Country' value={sellerProfile?.address?.country} />
										<Field label='State' value={sellerProfile?.address?.state} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className='row'>
					{/* Bank Details */}
					<div className='col-xl-6 col-md-12 pb-3'>
						<div className='profile-card'>
							<div className='profile-card-header'>
								<i className='bi bi-bank me-2' style={{ color: "#0ea5e9" }}></i>
								<span>Bank Details</span>
							</div>
							<div className='profile-card-body'>
								<Field label='Bank Business Name' value={sellerProfile?.bankDetails?.bankBusinessName} strong />
								<div className='row'>
									<div className='col-sm-6'>
										<Field label='Bank Name' value={sellerProfile?.bankDetails?.bankName} />
										<Field label='Account Number' value={sellerProfile?.bankDetails?.accountNumber} />
									</div>
									<div className='col-sm-6'>
										<Field label='Branch Name' value={sellerProfile?.bankDetails?.branchName} />
										<Field label='IFSC / Sort Code' value={sellerProfile?.bankDetails?.IFSCCode} />
									</div>
								</div>
							</div>
						</div>
					</div>

					{/* Store Information */}
					<div className='col-xl-6 col-md-12 pb-3'>
						<div className='profile-card'>
							<div className='profile-card-header'>
								<i className='bi bi-shop me-2' style={{ color: "#16a34a" }}></i>
								<span>Store Information</span>
							</div>
							<div className='profile-card-body'>
								<div className='d-flex flex-column flex-md-row align-items-center align-items-md-start' style={{ gap: "20px" }}>
									<div className='text-center'>
										{sellerProfile?.logo ? (
											<img
												src={sellerProfile.logo}
												alt='Store Logo'
												style={{ width: "110px", height: "110px", borderRadius: "12px", objectFit: "cover", border: "3px solid #e2e8f0", cursor: "pointer" }}
												onClick={() => setLightboxImage(sellerProfile.logo)}
												onError={(e) => {
													e.target.onerror = null;
													e.target.src = defaultImage;
												}}
											/>
										) : (
											<div style={{ width: "110px", height: "110px", borderRadius: "12px", border: "2px dashed #e2e8f0", display: "flex", alignItems: "center", justifyContent: "center", color: "#94a3b8", fontSize: "12px", textAlign: "center", padding: "10px" }}>No Logo</div>
										)}
										<div className='mt-2' style={{ fontSize: "12px", color: "#94a3b8" }}>
											Store Logo
										</div>
									</div>
									<div className='flex-grow-1 w-100'>
										<div className='row'>
											<div className='col-sm-6'>
												<Field label='Store Name' value={sellerProfile?.storeName} strong />
												<Field label='Business Name' value={sellerProfile?.businessName} />
											</div>
											<div className='col-sm-6'>
												<Field label='Business Type' value={sellerProfile?.businessType} />
												<Field label='Category' value={sellerProfile?.category?.name || sellerProfile?.category} />
											</div>
										</div>
										<div className='row'>
											<div className='col-sm-6'>
												<Field
													label='Instagram'
													value={
														sellerProfile?.instagramHandle ? (
															<a href={`https://instagram.com/${sellerProfile.instagramHandle}`} target='_blank' rel='noopener noreferrer' style={{ color: "#e54a13", textDecoration: "none" }}>
																@{sellerProfile.instagramHandle}
															</a>
														) : (
															"-"
														)
													}
												/>
											</div>
											<div className='col-sm-6'>
												<Field
													label='TikTok'
													value={
														sellerProfile?.tiktokHandle ? (
															<a href={`https://tiktok.com/@${sellerProfile.tiktokHandle}`} target='_blank' rel='noopener noreferrer' style={{ color: "#e54a13", textDecoration: "none" }}>
																@{sellerProfile.tiktokHandle}
															</a>
														) : (
															"-"
														)
													}
												/>
											</div>
										</div>
										{sellerProfile?.description && <Field label='Description' value={sellerProfile.description} />}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/* Uploaded Documents */}
				{hasDocs && (
					<div className='row'>
						<div className='col-12 pb-3'>
							<div className='profile-card'>
								<div className='profile-card-header'>
									<i className='bi bi-file-earmark-text-fill me-2' style={{ color: "#ef4444" }}></i>
									<span>Uploaded Documents</span>
								</div>
								<div className='profile-card-body'>
									<div className='row'>
										{docs.map(({ label, sub, field, icon }) => (
											<div className='col-md-4 mb-3' key={field}>
												<div style={{ fontSize: "13px", fontWeight: 500, color: "#334155" }}>{label}</div>
												<div style={{ fontSize: "11px", color: "#94a3b8", marginBottom: "8px" }}>{sub}</div>
												{sellerProfile?.[field] ? (
													<div onClick={() => setLightboxImage(sellerProfile[field])} style={{ position: "relative", width: "100%", height: "180px", borderRadius: "10px", overflow: "hidden", border: "1px solid #e2e8f0", cursor: "pointer", backgroundColor: "#f8fafc" }}>
														<img
															src={sellerProfile[field]}
															alt={label}
															style={{ width: "100%", height: "100%", objectFit: "contain" }}
															onError={(e) => {
																e.target.onerror = null;
																e.target.src = defaultImage;
															}}
														/>
													</div>
												) : (
													<div style={{ width: "100%", height: "180px", backgroundColor: "#f8fafc", border: "2px dashed #e2e8f0", borderRadius: "10px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", color: "#94a3b8", gap: "6px" }}>
														<i className={`bi ${icon}`} style={{ fontSize: "28px" }}></i>
														<span style={{ fontSize: "12px" }}>Not uploaded</span>
													</div>
												)}
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>

			{/* Custom CSS for better styling */}
			<style>{`
        .seller-shop-detail .profile-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          overflow: hidden;
          height: 100%;
          transition: box-shadow 0.2s ease;
        }
        .seller-shop-detail .profile-card:hover {
          box-shadow: 0 6px 20px rgba(15,23,42,0.06);
        }
        .seller-shop-detail .profile-card-header {
          padding: 14px 20px;
          font-size: 14px;
          font-weight: 600;
          color: #0f172a;
          background: #f8fafc;
          border-bottom: 1px solid #e2e8f0;
          display: flex;
          align-items: center;
        }
        .seller-shop-detail .profile-card-body {
          padding: 20px;
        }
        .seller-shop-detail .field-label {
          font-size: 12px;
          color: #64748b;
          margin-bottom: 2px;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          font-weight: 500;
        }
        .seller-shop-detail .field-value {
          font-size: 14px;
          color: #0f172a;
          word-break: break-word;
        }
        .seller-shop-detail .field-value.strong {
          font-weight: 600;
        }
        .seller-shop-detail .field-row {
          margin-bottom: 14px;
        }
      `}</style>

			{/* Image Lightbox */}
			{lightboxImage && (
				<div
					onClick={() => setLightboxImage(null)}
					style={{
						position: "fixed",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: "rgba(0,0,0,0.85)",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						zIndex: 9999,
						cursor: "pointer",
					}}>
					<img
						src={lightboxImage}
						alt='Document Preview'
						style={{
							maxWidth: "90vw",
							maxHeight: "90vh",
							objectFit: "contain",
							borderRadius: "8px",
						}}
						onClick={(e) => e.stopPropagation()}
					/>
					<div
						style={{
							position: "absolute",
							top: "20px",
							right: "30px",
							color: "#fff",
							fontSize: "2rem",
							cursor: "pointer",
						}}
						onClick={() => setLightboxImage(null)}>
						&times;
					</div>
				</div>
			)}
		</>
	);
};

export default connect(null, {
	getSellerProfile,
	sellerIsBlock,
	getSellerProduct,
})(Shop);

const Field = ({ label, value, strong }) => {
	const display = value === 0 || value ? value : "-";
	return (
		<div className='field-row'>
			<div className='field-label'>{label}</div>
			<div className={`field-value${strong ? " strong" : ""}`}>{display}</div>
		</div>
	);
};
